import React from 'react';
import Navbar from '../components/Navbar';
import ProfileCard from '../components/ProfileCard';
import '../styles/Team.css'; 

const teamMembers = [
  {
    name: "Marek-Jerzy Pindera, PhD",
    title: "Principal Scientist and Operating Manager Professor Emeritus",
    imageSrc: "/assets/Pindera.png",
    description: "Research Focus: Micromechanics and homogenization of heterogeneous materials; mechanics of composite materials (analysis and computation); mixed boundary-value problems in anisotropic and layered materials",
    email: "emc_llc@comcast.net"
  },
  {
    name: "Heze Chen, PhD",
    title: "Research Consultant Assistant Professor",
    imageSrc: "/assets/Heze.jpg",
    description: "Research Focus: Development of a finite-volume method for structural analysis and design of elements subjected to torsional and flexural loading",
    email: "hc9xc@virginia.edu",
    linkedin: "https://www.linkedin.com/in/heze-chen-8ab818125/",
  },
  {
    name: "Samuel Segal",
    title: "Undergraduate Student at University of Virginia",
    imageSrc: "/assets/Samuel.png",
    description: "Research Assistant",
    email: "bgq9ar@virginia.edu",
    linkedin: "https://www.linkedin.com/in/samuel-segal-uva/",
  },
  {
    name: "Yilin Wang",
    title: "Undergraduate Student at University of Virginia",
    imageSrc: "/assets/Dylan.jpg",
    description: "Website Developer",
    email: "dylanwang762@gmail.com",
    linkedin: "https://www.linkedin.com/in/yilinwang762/",
  },
  {
    name: "Hanjun Xiao",
    title: "Undergraduate Student at University of Virginia",
    imageSrc: "/assets/Eddie.jpeg",
    description: "Website Developer",
    email: "eddiexiao2019@gmail.com",
    linkedin: "https://www.linkedin.com/in/hanjun-xiao-eddie/",
    github: "https://github.com/eddieX-2021",
  }
];

function Team() {
  return (
    <div>
      <header className="team-header">
        <h1>A Wide Network of Researchers</h1>
      </header>
      {teamMembers.map((member, index) => (
        <ProfileCard
          key={index}
          name={member.name}
          title={member.title}
          imageSrc={member.imageSrc}
          description={member.description}
        />
      ))}
    </div>
  );
}

export default Team;
